import PropTypes from 'prop-types'
import React from 'react'
import { Trans } from 'react-i18next'
import Badge from 'client/components/core/Badge'
import EntityExampleWrapperUi from './ui/EntityExampleWrapperUi'

const EntityExampleWrapper = ({
  children,
  label,
  warning = true,
  visible = true,
  skipTranslation,
}) =>
  visible ? (
    <EntityExampleWrapperUi>
      {children}
      <Badge warning={warning}>
        {skipTranslation ? label : <Trans parent="span">{label}</Trans>}
      </Badge>
    </EntityExampleWrapperUi>
  ) : (
    children
  )

EntityExampleWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  warning: PropTypes.bool,
  visible: PropTypes.bool,
  skipTranslation: PropTypes.bool,
}

export default EntityExampleWrapper
